import { useState } from "react"
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _single } from "../../../../../../core/services/dataBean/EntityCatalog";

interface Props {
    exportMap: Function;
    procedure: any;
    pushInfo?: Function;
    pushResume?: Function;
}

export const SACDP002 = ({ exportMap, procedure, pushInfo, pushResume }: Props) => {

    const { bean, setBean, instance } = useDataBean(_AdquisitionItem);
    const [invalid, setInvalid] = useState<boolean>(false)

    const saveSupplier = () => {
        exportMap(bean);
        if (pushInfo) {
            pushInfo(bean);
        }
        if (pushResume) {
            pushResume(bean.obs);
        }
    }

    return (
        <div className="row">

            <div className="row">
                <div className="col-md-12">
                    <label>Tipo de Necesidad</label>
                    <select className="form-control" value={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e.target.value }) }}>
                        <option value={""}>...</option>
                        <option value={"PAAF"}>PAA Forpo</option>
                        <option value={"PAAC"}>PAA Convenio</option>
                    </select>
                </div>
            </div>

            <div className="col-md-12">
                <label>Justificación:</label>
                <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
            </div>

            <div className="col-md-3 mt-2">
                <BasicButton children={"Confirmar Selección"} eventClick={() => {
                    if (bean.obs && bean.obs.length > 15 && bean.Type !== "") {
                        saveSupplier();
                    } else {
                        setInvalid(true);
                        toast.error("La justificación debe tener un mínimo de 15 caracteres");
                    }
                }} icon="ri-save-line" />

            </div>
        </div>
    )
}